import "../styles/general.css";
import "../styles/queries.css";
import "../styles/AddGoalCard.css";

function AddGoalCard({ index, habitName, unit, weight, inputChangeHandler }) {
  return (
    <div className="set-goal-grid" key={index}>
      <input
        id="habit-name"
        type="text"
        name="habitName"
        placeholder="Reading"
        value={habitName}
        required
        onChange={(e) => inputChangeHandler(e, index)}
      />
      <input
        id="habit-unit"
        type="text"
        name="unit"
        placeholder="hour/hours"
        value={unit}
        required
        onChange={(e) => inputChangeHandler(e, index)}
      />
      <input
        id="habit-weight"
        type="number"
        name="weight"
        placeholder="2"
        value={weight}
        required
        onChange={(e) => inputChangeHandler(e, index)}
      />
    </div>
  );
}

export default AddGoalCard;
